import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type QuickLinkInput = {
  iconSymbol?: string;
  iconClassName?: string;
  path: string;
  text: string;
};

@Component({
  selector: 'bnz-homepage-quick-link',
  templateUrl: './homepage-quick-link.component.html',
  styleUrls: ['./homepage-quick-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BnzHomepageQuickLinkComponent {
  @Input() iconSymbol?: string;
  @Input() iconClassName?: string = '';
  @Input() path: string;
  @Input() text: string;

  isExternalPath(): boolean {
    return this.path.startsWith('http://') || this.path.startsWith('https://');
  }
}
